var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.btnFlag)?_c('div',{staticStyle:{"width":"40px","height":"40px"},attrs:{"id":"GoTop"},on:{"click":function($event){return _vm.GoTop()}}},[_c('img',{staticClass:"glyphicon",attrs:{"src":require("../assets/images/top.png"),"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }